/**
 * Auth Module
 *
 * Authentication state management for web
 * Uses Legend-State with IndexedDB persistence
 * Integrates with NextAuth session on the app level
 */

export * from './stores';
export * from './models';
